import { Component, OnInit } from '@angular/core';
import { FormBuilder,FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { RegistrationService } from '../../../shared/services/registration.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { MasterService } from 'src/app/shared/services/master.service';
import { log } from 'console';

declare let $: any;
@Component({
  selector: 'app-ncd-screens',
  templateUrl: './ncd-screens.component.html',
  styleUrls: ['./ncd-screens.component.css'],
})
export class NcdScreensComponent implements OnInit {
  modelType: any = 2;
  result = []; targetQsnId = []; targetAnsId = []; ansLst = []; genderlst = [];
  lin = 0; supportedLanguages: any[]=[] ;srvySctn = [];

  serveyEntity: {id:number, surveyOrder: number, tragetSurveyId: number, surveyLang: { languageID: number, langStr: string, surveyID: number, id: number }[] } = {id:0, surveyOrder: null, tragetSurveyId: null, surveyLang: [] };
  sectionEntity: {id:number, sectionOrder: number, survey_id: number, sectionLang: { languageID: number, langStr: string, sectionID: number, id: number }[] } = {id:0, sectionOrder: null, survey_id: 0, sectionLang: [] };
  questionEntity: {id:number, questionOrder: number, section_id: number, answerType: { id: number }, regularExpression: string, mandatory: boolean, specialHandling: boolean, showScore: boolean, targetquestionID: number, targetanswerID: number, questionSeries: string, gender: number, placeHolder: string, questionLang: { languageID: number, langStr: string, questionID: number, id: number, summary: string }[] } =
    {id:0, questionOrder: null, section_id: null, answerType: { id: 0 }, regularExpression: '', gender: 0, mandatory: false, specialHandling: false, showScore: false, targetquestionID: 0, targetanswerID: 0, questionSeries: '', placeHolder: '', questionLang: [] };
  answerEntity: {id:number, answerOrder: number, question_id: number, score: number, answerLang: { languageID: number, langStr: string, answerID: number, id: number }[] } = {id:0, answerOrder: null, question_id: 0, score: null, answerLang: [] };
  
  num: any;
  modelheirarchy = "string";
  PageTitle = 'Manage Surveys';
  
  trackByIndex = index => index;

  parent_id: number = 0;
  delete_id: number = 0;
  entityName: any;
  entity: any;
  mode: string;
  records1: { id: number; createdOn: any; createdBy: any; modifiedBy: any; deleted: boolean; name: string; }[];

  constructor(
    public activeModal: NgbActiveModal,
    private regService: RegistrationService,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private master : MasterService
  ) {
    this.entityName = 'Survey';

    this.genderlst.push(
      { id: 1, name: 'Male' },
      { id: 2, name: 'Female' },
      { id: 3, name: 'Other' },
      { id: 4, name: 'All' }
    );
  }

  ngOnInit(): void {

    this.LoadData();
   this.records1=[
        {
            "id": 1,
            "createdOn": null,
            "createdBy": null,
            "modifiedBy": null,
            "deleted": false,
            "name": "English"
        }
    ]
    this.supportedLanguages = this.records1
     this.supportedLanguages.forEach((e, i) => {
          this.serveyEntity.surveyLang.push({ id: 0, langStr: '', languageID: i+1, surveyID: 0 });
          this.sectionEntity.sectionLang.push({ languageID: i+1, langStr: '', sectionID: 0, id: 0 });
          this.questionEntity.questionLang.push({ languageID: i+1, langStr: '', questionID: 0, id: 0, summary: '' });
          this.answerEntity.answerLang.push({ languageID: i+1, langStr: '', answerID: 0, id: 0 });
        });
  
       
}


  LoadData() {

    this.regService.getwithoutlogin(`survey/survey/getall`).subscribe({
      next: (res: any) => {
        if (res?.status === 'OK') {
          this.result = res.data;
          console.log( this.result)
        } else {
          this.toastr.error(res.message ?? 'Failed to fetch data');
        }
      },
      error: (err: HttpErrorResponse) => {
        this.toastr.error(err.message ?? 'An unexpected error occurred');
      },
    });
  }

  addEntity(modal_id: number = 0, parent_id: number = 0, SrvyId: number = 0) {
    if (modal_id == 3) {
      this.targetQsnId = [];
      this.entityName = 'AnswerType';
      this.regService.post(this.entityName, {}).subscribe({
        next: (res: any) => {
          if (res?.status === 'OK') {
            this.ansLst = res.data.sort(this.GetSortOrder('id'));
          } else {
            this.toastr.error(res.message ?? 'Failed to fetch data');
          }
        },
        error: (err: HttpErrorResponse) => {
          this.toastr.error(err.message ?? 'An unexpected error occurred');
        },
      });
      this.targetQsnId = [];
      this.result.forEach((e) => {
        if (e.id == SrvyId)
          e.sections.forEach((f) => {
            f.questions.forEach((g) => {
              this.targetQsnId.push({
                id: g.id,
                series: g.questionSeries,
                name: g.questionLang,
              });
            });
          });
      });
    }
    this.modelType = modal_id;
    this.parent_id = parent_id;

    this.addEntity1();
    let changeType = {
      '1': () => {
        (this.serveyEntity = {
          id: 0,
          surveyOrder: null,
          tragetSurveyId: null,
          surveyLang: [],
        }),
          this.supportedLanguages.forEach((e, i) => {
            this.serveyEntity.surveyLang.push({
              id: 0,
              langStr: '',
              languageID: i + 1,
              surveyID: 0,
            });
          });
      },
      '2': () => {
        (this.sectionEntity = {
          id: 0,
          sectionOrder: null,
          survey_id: null,
          sectionLang: [],
        }),
          this.supportedLanguages.forEach((e, i) => {
            this.sectionEntity.sectionLang.push({
              languageID: i + 1,
              langStr: '',
              sectionID: 0,
              id: 0,
            });
          });
      },
      '3': () => {
        (this.questionEntity = {
          id: 0,
          questionOrder: null,
          section_id: null,
          answerType: { id: 0 },
          gender: 4,
          regularExpression: '',
          mandatory: false,
          specialHandling: false,
          showScore: false,
          targetquestionID: 0,
          targetanswerID: 0,
          questionSeries: '',
          placeHolder: '',
          questionLang: [],
        }),
          this.supportedLanguages.forEach((e, i) => {
            this.questionEntity.questionLang.push({
              languageID: i + 1,
              langStr: '',
              questionID: 0,
              id: 0,
              summary: '',
            });
          });
      },
      '4': () => {
        (this.answerEntity = {
          id: 0,
          answerOrder: null,
          question_id: null,
          score: null,
          answerLang: [],
        }),
          this.supportedLanguages.forEach((e, i) => {
            this.answerEntity.answerLang.push({
              languageID: i + 1,
              langStr: '',
              answerID: 0,
              id: 0,
            });
          });
      },
    };
    changeType[this.modelType]();

    $('#myModal').modal('show');
  }

  editEntity(entity: any, modal_id: number = 0, SrvyId: number = 0) {
    if (modal_id == 3) {
      this.entityName = 'AnswerType';
      // this.regService.findAll(this.entityName, {}).subscribe({
      //   next: (res: any) => {
      //     if (res?.status === 'OK') {
      //       this.ansLst = res.data.sort(this.GetSortOrder('id'));
      //     } else {
      //       this.toastr.error(res.message ?? 'Failed to load data');
      //     }
      //   },
      //   error: (err: HttpErrorResponse) => {
      //     this.toastr.error(err.message ?? 'An unexpected error occurred');
      //   },
      // });

      this.targetQsnId = [];
      this.result.forEach((e) => {
        if (e.id == SrvyId)
          e.sections.forEach((f) => {
            f.questions.forEach((g) => {
              if (g.id != entity.id && g.questionOrder < entity.questionOrder)
                this.targetQsnId.push({
                  id: g.id,
                  series: g.questionSeries,
                  name: g.questionLang,
                });
            });
          });
      });
      this.targtQsnChange(entity.targetquestionID);
    }
    this.modelType = modal_id;
    this.clearData(modal_id);
    const editData = JSON.parse(JSON.stringify(entity));

    let parentId = {
      '1': () => {
        this.supportedLanguages.forEach((e, i) => {
          if (
            editData.surveyLang.filter((f) => f.languageID == i + 1).length == 0
          )
            editData.surveyLang.push({
              id: 0,
              langStr: '',
              languageID: i + 1,
              surveyID: 0,
            });
        }),
          editData.surveyLang.sort(this.GetSortOrder('languageID')),
          (this.serveyEntity = editData);
      },
      '2': () => {
        this.supportedLanguages.forEach((e, i) => {
          if (
            editData.sectionLang.filter((f) => f.languageID == i + 1).length ==
            0
          )
            editData.sectionLang.push({
              languageID: i + 1,
              langStr: '',
              sectionID: 0,
              id: 0,
            });
        }),
          editData.sectionLang.sort(this.GetSortOrder('languageID')),
          (this.sectionEntity = editData),
          (this.parent_id = this.sectionEntity.survey_id);
      },
      '3': () => {
        this.supportedLanguages.forEach((e, i) => {
          if (
            editData.questionLang.filter((f) => f.languageID == i + 1).length ==
            0
          )
            editData.questionLang.push({
              languageID: i + 1,
              langStr: '',
              questionID: 0,
              id: 0,
              summary: '',
            });
        }),
          editData.questionLang.sort(this.GetSortOrder('languageID')),
          (this.questionEntity = editData),
          (this.parent_id = this.questionEntity.section_id);
      },
      '4': () => {
        this.supportedLanguages.forEach((e, i) => {
          if (
            editData.answerLang.filter((f) => f.languageID == i + 1).length == 0
          )
            editData.answerLang.push({
              languageID: i + 1,
              langStr: '',
              answerID: 0,
              id: 0,
            });
        }),
          editData.answerLang.sort(this.GetSortOrder('languageID')),
          (this.answerEntity = editData),
          (this.parent_id = this.answerEntity.question_id);
      },
    };
    parentId[this.modelType]();

    this.editEntity1(editData);
    $('#myModal').modal('show');
  }

  closeWindow() {
      if (this.currentOpenModalId) {
      $(`#${this.currentOpenModalId}`).modal('hide');
      this.currentOpenModalId = null;
    }
    this.entity = null;
    this.entity = { id: 0 };
    $('#myModal').modal('hide');
  }

  clearData(id: number) {
    let changeType = {
      '1': () => {
        (this.serveyEntity = {
          id: 0,
          surveyOrder: null,
          tragetSurveyId: null,
          surveyLang: [],
        }),
          this.supportedLanguages.forEach((e, i) => {
            this.serveyEntity.surveyLang.push({
              id: 0,
              langStr: '',
              languageID: i + 1,
              surveyID: 0,
            });
          });
      },
      '2': () => {
        (this.sectionEntity = {
          id: 0,
          sectionOrder: null,
          survey_id: null,
          sectionLang: [],
        }),
          this.supportedLanguages.forEach((e, i) => {
            this.sectionEntity.sectionLang.push({
              languageID: i + 1,
              langStr: '',
              sectionID: 0,
              id: 0,
            });
          });
      },
      '3': () => {
        (this.questionEntity = {
          id: 0,
          questionOrder: null,
          section_id: null,
          answerType: { id: 0 },
          gender: 4,
          regularExpression: '',
          mandatory: false,
          specialHandling: false,
          showScore: false,
          targetquestionID: 0,
          targetanswerID: 0,
          questionSeries: '',
          placeHolder: '',
          questionLang: [],
        }),
          this.supportedLanguages.forEach((e, i) => {
            this.questionEntity.questionLang.push({
              languageID: i + 1,
              langStr: '',
              questionID: 0,
              id: 0,
              summary: '',
            });
          });
      },
      '4': () => {
        (this.answerEntity = {
          id: 0,
          answerOrder: null,
          question_id: null,
          score: null,
          answerLang: [],
        }),
          this.supportedLanguages.forEach((e, i) => {
            this.answerEntity.answerLang.push({
              languageID: i + 1,
              langStr: '',
              answerID: 0,
              id: 0,
            });
          });
      },
    };
    changeType[this.modelType]();
  }

  targtQsnChange(id: null) {
    this.targetAnsId = [];
    this.result.forEach((e) => {
      e.sections.forEach((f) => {
        f.questions.forEach((g) => {
          if (g.id == id)
            g.answers.forEach((h) => {
              this.targetAnsId.push({ id: h.id, name: h.answerLang });
            });
        });
      });
    });
  }

  async saveEntity() {
    if (
      this.modelType == 1 &&
      this.serveyEntity.surveyLang[0].langStr == '' &&
      this.serveyEntity.surveyLang[1].langStr == '' &&
      this.serveyEntity.surveyLang[2].langStr == ''
    ) {
      this.toastr.warning('Enter Survey in English');
      return;
    }
    if (
      this.modelType == 2 &&
      this.sectionEntity.sectionLang[0].langStr == '' &&
      this.sectionEntity.sectionLang[1].langStr == '' &&
      this.sectionEntity.sectionLang[2].langStr == ''
    ) {
      this.toastr.warning('Enter Section in English');
      return;
    }
    if (this.modelType == 3) {
      if (this.questionEntity.answerType.id == 0) {
        this.toastr.warning('Select all Mandatory Fields');
        return;
      }
      if (
        this.questionEntity.questionLang[0].langStr == '' &&
        this.questionEntity.questionLang[1].langStr == '' &&
        this.questionEntity.questionLang[2].langStr == ''
      ) {
        this.toastr.warning('Enter Question in English');
        return;
      }
    }
    if (
      this.modelType == 4 &&
      this.answerEntity.answerLang[0].langStr == '' &&
      this.answerEntity.answerOrder[1].langStr == '' &&
      this.answerEntity.answerLang[2].langStr == ''
    ) {
      this.toastr.warning('Enter Answer in English');
      return;
    }

    let saveData = {
      '1': () => (this.entity = this.serveyEntity),
      '2': () => {
        this.sectionEntity.survey_id = this.parent_id;
        this.entity = this.sectionEntity;
      },
      '3': () => {
        this.questionEntity.section_id = this.parent_id;
        this.entity = this.questionEntity;
      },
      '4': () => {
        this.answerEntity.question_id = this.parent_id;
        this.entity = this.answerEntity;
      },
    };
    saveData[this.modelType]();
    this.entityName = ['Survey', 'Section', 'Question', 'Answer'][
      this.modelType - 1
    ];
    if (this.mode == 'Add') {
      let deleteData = {
        '1': () => {
          delete this.entity.id,
            this.entity.surveyLang.forEach((e) => {
              delete e.surveyID, delete e.id;
            });
        },
        '2': () => {
          delete this.entity.id,
            this.entity.sectionLang.forEach((e) => {
              delete e.sectionID, delete e.id;
            });
        },
        '3': () => {
          delete this.entity.id,
            this.entity.questionLang.forEach((e) => {
              delete e.questionID, delete e.id;
            });
        },
        '4': () => {
          delete this.entity.id,
            this.entity.answerLang.forEach((e) => {
              delete e.answerID, delete e.id;
            });
        },
      };
      deleteData[this.modelType]();
    }
    this.saveEntity1(false).then(() => this.LoadData());
    this.entity.modifiedBy = this.getUserName();
    $('#myModal').modal('hide');
    delete this.entity.authority;
  }

  getUserName(): string {
    const loginName: string = JSON.parse(
      sessionStorage.getItem('currentUser')
    ).login_name.toString();
    return loginName;
  }

  async saveEntity1(
    isPageNation: boolean = true,
    isLoginChanged: boolean = false,
    isSave2: boolean = false,
    methodName: string = '/save',
    isJSON: boolean = true
  ) {
    if (+this.entity.id == 0) {
      delete this.entity.id;
    }

    // const saveCall = isSave2
    //   ? this.regService.save2(
    //       this.entityName,
    //       methodName,
    //       JSON.stringify(this.entity),
    //       isJSON
    //     )
    //   : this.regService.savencd(this.entityName, JSON.stringify(this.entity));

    // saveCall.subscribe({
    //   next: (res: any) => {
    //     if (res?.status === 'OK') {
    //       if (isLoginChanged) {
    //         localStorage.setItem('user', JSON.stringify(res.data));
    //       }
    //       if (isPageNation) {
    //         this.getPage();
    //       } else {
    //         this.records1 = res.data;
    //       }
    //       this.toastr.success(res.message ?? 'Saved successfully');
    //     } else {
    //       this.toastr.error(res.message ?? 'Failed to save');
    //     }
    //   },
    //   error: (err: HttpErrorResponse) => {
    //     this.toastr.error(err.message ?? 'An unexpected error occurred');
    //   },
    //   complete: () => {
    //     // any final steps
    //   },
    // });
  }

  changeClass() {
    $('.collapse')
      .on('shown.bs.collapse', function () {
        $(this)
          .parent()
          .find('.fa-plus')
          .removeClass('fa-plus')
          .addClass('fa-minus');
      })
      .on('hidden.bs.collapse', function () {
        $(this)
          .parent()
          .find('.fa-minus')
          .removeClass('fa-minus')
          .addClass('fa-plus');
      });
  }

  setDefaultValues(): any {
    return { id: 0, name: '', surveyOrder: '' };
  }

  deleteRecord(id: any = null, modal_id: number = 0) {
    $('#myModal_delete').modal('show');
    this.delete_id = id;
    this.modelType = modal_id;
  }

  confirm(OKAndCancel: boolean) {
  this.entityName = ['Survey', 'Section', 'Question', 'Answer'][this.modelType - 1];

  if (OKAndCancel) {
    this.deleteEntity(this.delete_id).then(() => this.LoadData());
  }

  this.closeWindow(); // Programmatically close the currently open modal
  }

  GetSortOrder(key) {
    return function (a, b) {
      if (a[key] > b[key]) {
        return 1;
      } else if (a[key] < b[key]) {
        return -1;
      }
      return 0;
    };
  }

  InputFocus() {
    $('.focus-text').focus(function () {
      $(this).closest('div').addClass('focus-t');
    });
    $('.focus-text').blur(function () {
      if ($('.focus-text').length > 0 && $('.focus-text').val() != '') {
        $(this).closest('div').addClass('focus-t');
      } else {
        $(this).closest('div').removeClass('focus-t');
      }
    });
  }

  async deleteEntity(id: any = null) {
    // this.loading = true;
    // await this.entityService.deleteById(this.entityName, id).
    //   catch(this.httpSvc.handleError).
    //   then((res: Response) => {
    //     if (res) {
    //       let result = res.json();
    //       this.loading = false;
    //       //console.log(result);
    //       if (result.status == 'OK') {
    //         this.getPage();
    //         //this.toastr.success(result.message);
    //       }
    //       else
    //         this.toastr.error('Failed to delete');
    //     }
    //     else
    //       this.loading = false, this.toastr.error(`An error occurred while processing your request`);
    //   });
  }

  async getPage() {
    // const isMultipleVillages = true;
    // this.loading = true;
    // this.pageService.is_MasterURL.subscribe(s => this.isMasterURL = s);
    // if (this.isMasterURL == false)
    //   this.pageService.is_Family.subscribe(s => this.isFamily = s);
    // await (this.isFamily ? this.entityService.pagination2(this.entityName, JSON.stringify(this.entity)) : this.entityService.pagination(this.entityName, `{"loginName":"${this.userName}"}`, this.pageNumber, this.recordsPerPage, this.isMasterURL)).
    //   catch(this.httpSvc.handleError).
    //   then((res: Response) => {
    //     if (res) {
    //       let result = res.json();
    //       this.loading = false;
    //       if (result.data) {
    //         if (this.isFamily)
    //           this.records = result.data;
    //         else {
    //           this.records = result.data.content;
    //           this.totalPages = result.data.totalPages;
    //           this.pageService.setPages = this.totalPages;
    //           this.pageService.setTableData = this.records;
    //           this.pageService.setPageNumber = this.pageNumber;
    //         }
    //       }
    //     }
    //     // else
    //     //   this.loading = false, this.toastr.error(`An error occurred while processing your request`);
    //   });
  }

  addEntity1() {
    this.mode = 'Add';
  }

  editEntity1(entity: any) {
    this.entity = entity;
    this.mode = 'Update';
  }

checkPermission(permission: string): boolean {
  // replace with actual logic
  return true;
}

  currentOpenModalId: string | null = null;

  openModal(modalId: string) {
    // Close existing modal if open
    if (this.currentOpenModalId && this.currentOpenModalId !== modalId) {
      $(`#${this.currentOpenModalId}`).modal('hide');
    }

    // Open requested modal
    $(`#${modalId}`).modal({ backdrop: 'static', keyboard: false });
    this.currentOpenModalId = modalId;
  }



}

export interface IList {
  id: number;
  name: string;
  scheduleCasteType: string;
  castettype: string;
  shortName: string;
}
